module.exports = __webpack_public_path__ + "static/media/eq.ef9573ef.svg";